import api from "../services/api";

import { ICategoria, ISearchRequest, ISearchResponse } from "../interfaces";

interface ICategoriaInsertResponse {
    categoria: ICategoria;
    message: string;
}

class CategoriaRepository {

    public List = async (searchRequest: ISearchRequest): Promise<ISearchResponse<ICategoria>> => {

        const response = await api.get<ISearchResponse<ICategoria>>("categoria", {
            params: {
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });

        return response.data;
    }

    public Insert = async ({ nome, status }: ICategoria): Promise<ICategoriaInsertResponse> => {
        const response = await api.post<ICategoriaInsertResponse>("categoria", { nome, status });

        return response.data;
    }
}

const categoriaRepository = new CategoriaRepository();
export default categoriaRepository;
